import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { summaryService } from "../api";
import { getMainProduct, getProduct, getThread } from "../redux/selectors";

const BestSources: React.FC = () => {
  const feedFilter = useSelector(getFeedFilter);
  const thread = useSelector(getThread);
  const product = useSelector(getProduct);
  const mainProduct = useSelector(getMainProduct);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [keys, setKeys] = useState([]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (thread && mainProduct && product) {
      let params = {
        thread_id: +thread.id,
        product_id: window.location.pathname.includes("main")
          ? mainProduct?.id
          : product,
        from: feedFilter.from.slice(0, 10) + " 00:00:00",
        to: feedFilter.to.slice(0, 10) + " 23:59:59",
        type: "social",
        limit: 4,
      };
      setLoading(true);
      summaryService
        .loadSourceTop(params)
        .then((resp) => {
          setKeys(resp);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [thread, feedFilter, product, mainProduct]);

  return (
    <div className="white-block">
      <div className="flex-space margin-bottom">
        <div>
          <p className="block-title">
            Лучшие источники{" "}
            <InfoCircleOutlined className="info" onClick={showDrawer} />
          </p>
        </div>
      </div>
      {loading ? (
        <div className="feed-posts-loader">
          <LoadingOutlined />
        </div>
      ) : (
        <div className="grid4">
          {keys?.map((item: any, id) => (
            <div className="grid-block gray-block" key={id}>
              <div className="margin-bottom">
                <a href={item?.url} className="flex align-block">
                  {item?.key != "gs" && (
                    <img
                      //src={"/" + item?.key + ".png"}
                      src={item?.logo}
                      alt=""
                      className="source-icon"
                    />
                  )}
                  {/*findSource(item?.key)*/}
                  <div className="block-title top-post__text">{item.title}</div>
                </a>
              </div>
              <div className="margin-bottom">
                <div className="title-small">
                  {item?.media_presence?.toFixed(2)}%
                </div>
              </div>
              <div className="margin-bottom">
                <p className="grey">Просмотров</p>
                <div className="title-middle">
                  {item?.viewed.toLocaleString()}{" "}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <Drawer title="Что отображает эта таблица?" onClose={onClose} open={open}>
        <p className="purple-border">
          В таблице представлены ТОП-4 источника за период с наиболее высокими
          показателями ERR и количеством просмотров.
        </p>
        <p className="title-small">Как интерпретировать данные</p>
        <ol>
          <li>
            Временные интервалы: Вы можете выбрать различные временные интервалы
            для анализа динамики.
          </li>
        </ol>
        <p className="title-small">Источники данных</p>
        <ul>
          <li>Telegram</li>
          <li>Вконтакте</li>
          <li>Одноклассники</li>
          <li>Youtube</li>
          <li>Дзен</li>
        </ul>
        <p className="gray-block">
          <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в реальном
          времени, что позволяет вам следить за актуальными трендами и реакцией
          аудитории на ваш контент
        </p>
      </Drawer>
    </div>
  );
};

export default BestSources;
